<template>
  <div class="card-base" v-loading="isLoading">
    <div class="widget-header ph-10 pt-10">
      <h5 class="pb-10 display-block">
        Detections
        <el-link @click="loadDocumentation('dashboard-behavior-analysis')" :underline="false">
          <i class="material-icons">help_outline</i>
        </el-link>
        <div class="float-right subtitle2">Past 1 month</div>
      </h5>
      <el-tabs v-model="activeView">
        <el-tab-pane label="SIGNALS" name="integrations">
          <div class="flex justify-center align-center integrations-list">
            <div class="box grow animated fadeInLeft full-height" style="overflow-y: auto;">
              <!-- <div class="cursor-pointer mb-5">
                <div class="flex">
                  <span class="ml-0 box grow body2 light-bold">Confluera</span>
                  <span class="ml-0 box body2 light-bold">{{ detectionCount }}</span>
                </div>
              </div> -->
              <div
                  v-for="(integrationCount, key, index) in integrationDetections"
                  :key="key"
                  class="cursor-pointer mb-5"
                  @click="gotoAccountkeyDetections(key)"
              >
                <el-divider v-if="index !== 0"></el-divider>
                <div class="flex pt-10">
                  <span class="ml-0 box grow body2 light-bold">{{ getIntegrationAccountTitle(key) }}</span>
                  <span class="ml-0 box body2 light-bold">{{ integrationCount }}</span>
                </div>
                <el-divider class="mt-5" v-if="index === $_.keys(integrationDetections).length - 1"></el-divider>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <!-- <div
            class="pt-10 flex justify-center align-center scrollarrow-section"
            v-if="!isLoading && isIntegrationListOverflow"
          >
            <i class="fas fa-angle-up cursor-pointer" @click="scrollUp($event)"></i>
            <i class="fas fa-angle-down cursor-pointer" @click="scrollDown($event)"></i>
          </div> -->
          <div style="text-align: end;">
            <span class="scroll-down">scroll down for more</span>
          </div>
          <div class="pt-5 flex justify-center align-center cursor-pointer">
            <router-link :to="{ name: 'integrations' }">
              <a class="display-inline-block capitalize-first-letter">Add Integrations</a>
            </router-link>
          </div>
        </el-tab-pane>
        <el-tab-pane label="TYPES" name="detections">
          <div class="flex justify-center align-center tactics-list" style="overflow-y: auto;">
            <div class="box grow animated fadeInLeft full-height">
              <div
                  v-for="(tactic, index) in detectionTactics"
                  :key="tactic.step"
                  class="cursor-pointer mb-5"
                  :class="{ 'display-none': tactic.count == 0 }"
                  @click="gotoView(tactic.title)"
              >
                <el-divider v-if="index !== 0"></el-divider>
                <div class="flex pt-10">
                  <span class="ml-0 box grow body2 light-bold">{{ tactic.title }}</span>
                  <span class="ml-0 box body2 light-bold">{{ tactic.count }}</span>
                </div>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <!-- <div
            class="pt-10 flex justify-center align-center scrollarrow-section"
            v-if="!isLoading && isTacticListOverflow"
          >
            <i class="fas fa-angle-up cursor-pointer" @click="scrollUp($event)"></i>
            <i class="fas fa-angle-down cursor-pointer" @click="scrollDown($event)"></i>
          </div> -->
          <div style="text-align: end;">
            <span class="scroll-down">scroll down for more</span>
          </div>
          <div class="pt-5 flex justify-center align-center cursor-pointer">
            <router-link :to="{ name: 'integrations' }">
              <a class="display-inline-block capitalize-first-letter">Add Integrations</a>
            </router-link>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import {registerInverval, destroyInverval} from '@/utilities/global.interval'

import DonutChartJs from '@/components/chart/DonutChartJs.vue'
import DonutholeChartLabelPlugin from '@/components/chart/plugins/donuthole-chart-label.plugin'

import {AttackChainCommandTactics} from '@/constants/attack-chain.constants'
import {DASHBOARD_BEHAVIOR_INTERVAL} from '@/constants/polling-interval.constants'
import {
  IOC_TACTIC_SUMMARY_REQ,
  IOC_TACTIC_SUMMARY_SUCCESS,
  IOC_DETECTIONS_LIST_RESET_STATUS,
  PRIVILEGED_ACTIONS_LIST_RESET_STATUS
} from '@/store/modules/detections/detections.type'

export default {
  name: 'MitreTacticAnalysis',
  mixins: [loadDocumentationMixin],
  props: {
    atRisk: {
      type: Boolean,
      default: false
    },
    agent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeView: 'integrations',
      isLoading: false,
      detectionCount: 0,
      detectionTactics: _.cloneDeep(AttackChainCommandTactics),
      integrationDetections: {},
      tacticIntervalId: {}
    }
  },
  mounted() {
    this.detectionTactics.forEach(tactic => {
      tactic.active = false
      tactic.count = 0
    })
    this.setButtonPosition()

    this.debounceResize = _.debounce(this.setButtonPosition, 500)
    // window resize event
    window.addEventListener('resize', this.debounceResize)
  },
  created() {
    if (_.isEmpty(this.tacticIntervalId)) {
      this.isLoading = true
      this.fetchIocList()
    }
  },
  methods: {
    setButtonPosition() {
      try {
        const chartElm = this.$el.getElementsByClassName('command-chart')[0]
        if (chartElm) {
          let divWidth = chartElm.clientWidth
          let hiddenButtonElm = this.$el.getElementsByClassName('hidden-center-button')[0]
          hiddenButtonElm.style.marginLeft = `${divWidth / 8 - 20}px`
        }
      } catch (err) {
        console.log(err)
      }
    },
    pollTacticAnalysis() {
      this.tacticIntervalId = setTimeout(() => {
        this.fetchIocList()
      }, DASHBOARD_BEHAVIOR_INTERVAL)

      registerInverval(this.tacticIntervalId)
    },
    fetchIocList() {
      if (this.tacticIntervalId) {
        destroyInverval(this.tacticIntervalId)
      }
      this.$store.dispatch(IOC_TACTIC_SUMMARY_REQ, {dateRangeSel: 'PAST_1_MONTH'}).then(
        detections => {
          // {
          //   "iocCount": 142151,
          //   "tacticCountMap": {
          //     "Impact": 35,
          //     "Lateral Movement": 4,
          //     "Credential Access": 138606,
          //     "Discovery": 25,
          //     "Initial Access": 3263,
          //     "Persistence": 29,
          //     "Exfiltration": 0,
          //     "Execution": 23,
          //     "Privilege Escalation": 2,
          //     "Unknown": 0,
          //     "Defense Evasion": 164,
          //     "Collection": 0,
          //     "Command and Control": 0
          //   },
          //   "integrationCountMap": {
          //     "ALB": 5,
          //     "SNYK": 13
          //   }
          // }
          this.integrationDetections = detections.integrationCountMap
          this.detectionCount = detections.iocCount
          for (let tactic in detections.tacticCountMap) {
            this.addToTacticCount(tactic, detections.tacticCountMap[tactic])
          }
          this.$store.dispatch(IOC_TACTIC_SUMMARY_SUCCESS)
          this.isLoading = false
          this.pollTacticAnalysis()
        },
        errMsg => {
          this.pollTacticAnalysis()
        }
      )
    },
    addToTacticCount(command, count) {
      if (!_.isEmpty(command)) {
        let tactic = _.find(this.detectionTactics, {command: command.toUpperCase().replace(/\s/g, '_')})
        if (tactic) {
          if (this.atRisk) {
            tactic.color = '#f24a6c'
          } else {
            tactic.color = '#1a90fa'
          }
          tactic.count = count
        }
      }
    },
    getTacticValuesByKey(key) {
      return _.chain(this.detectionTactics)
        .filter(tactic => {
          return tactic.count > 0
        })
        .map(key)
        .value()
    },
    chartHoverEvent(evt, elements) {
      let activeTactic = this.$refs.tacticChart.$data._chart.getElementAtEvent(evt)
      if (activeTactic.length) {
        let hightligtedTactic = _.find(this.detectionTactics, {
          title: this.attackChainData.labels[activeTactic[0]._index]
        })

        let idx = _.findIndex(this.detectionTactics, {
          title: this.attackChainData.labels[activeTactic[0]._index]
        })
        if (hightligtedTactic) {
          this.$set(this.detectionTactics[idx], 'active', true)
          hightligtedTactic.active = true
        }
      }
    },
    chartMouseoutEvent(evt, elements) {
      console.log(evt)
    },
    gotoView(tacticTitle) {
      // let tacticTitle = this.attackChainData.labels[pieIndex.value]
      // let tactic = _.find(this.detectionTactics, {
      //   title: tacticTitle
      // })
      this.$router.push({
        name: 'detections',
        query: {tactic: tacticTitle, date_range: 'PAST_1_MONTH'}
      })
    },
    gotoAccountkeyDetections(integration) {
      // if (integration.toLowerCase() === 'confluera') {
      //   return this.gotoDetections()
      // }
      this.$router.push({
        name: 'account-iocs',
        query: {integrationType: integration}
      })
    },
    gotoDetections() {
      this.$router.push({
        name: 'detections',
        query: {date_range: 'PAST_1_MONTH'}
      })
    },
    getIntegrationAccountTitle(type) {
      switch (type) {
        case 'CONFLUERA':
          return 'Confluera'
        case 'CARBONBLACK':
          return 'Carbon Black'
        case 'ALB':
          return 'AWS Load Balancer'
        case 'GUARDDUTY':
          return 'Guard Duty'
        case 'PAN':
          return 'Palo Alto Networks'
        case 'TRENDMICRO':
          return 'TrendMicro'
        case 'SNYK':
          return 'Snyk'
        case 'RDS':
          return 'AWS RDS'
        case 'CLOUDTRAIL':
          return 'AWS Cloud Control Plane'
        case 'DEVO':
          return 'Devo'
        case 'CLOUDTRAIL_HISTORY':
          return 'AWS CloudTrail History Events'
        case 'AZURELOG':
          return 'Azure Logs'
      }
    },
    scrollDown(event) {
      let scrollSelector = '.tactics-list'
      if (this.activeView === 'integrations') {
        scrollSelector = '.integrations-list'
      }
      let listElement = this.$el.querySelectorAll(scrollSelector)[0]
      listElement.scrollTop += 10
    },
    scrollUp() {
      let scrollSelector = '.tactics-list'
      if (this.activeView === 'integrations') {
        scrollSelector = '.integrations-list'
      }
      let listElement = this.$el.querySelectorAll(scrollSelector)[0]
      listElement.scrollTop -= 10
    }
  },
  computed: {
    donutholeChartLabelPlugin() {
      return DonutholeChartLabelPlugin
    },
    attackChainData() {
      return {
        centerDonutTitle: [String(this.detectionCount), 'Detections'],
        datasets: [
          {
            data: this.getTacticValuesByKey('count'),
            backgroundColor: this.getTacticValuesByKey('color')
          }
        ],
        labels: this.getTacticValuesByKey('title')
      }
    },
    behaviorChartOptions() {
      return {
        width: 250,
        height: 250,
        rotation: 0.8 * Math.PI,
        circumference: 2 * Math.PI,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 30
          }
        },
        tooltips: {
          enabled: true,
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, object) {
              return `${object.labels[tooltipItem.index]} ${object.datasets[0].data[tooltipItem.index]}` || ''
            }
          }
        },
        onHover: this.chartHoverEvent,
        mouseLeave: this.chartMouseoutEvent
      }
    },
    isTacticListOverflow() {
      if (this.$el) {
        let scrollSelector = '.tactics-list'
        let tacticCount = _.filter(this.detectionTactics, tactic => {
          return tactic.count > 0
        })
        let listItemHeight = tacticCount.length * 30
        let listElemHeight = this.$el.querySelector(scrollSelector).clientHeight
        return listItemHeight > listElemHeight
      }
      return false
    },
    isIntegrationListOverflow() {
      if (this.$el) {
        let scrollSelector = '.integrations-list'
        let listItemHeight = _.keys(this.integrationDetections).length * 30
        let listElemHeight = this.$el.querySelector(scrollSelector).clientHeight
        return listItemHeight > listElemHeight
      }
      return false
    }
  },
  beforeDestroy() {
    this.$store.dispatch(IOC_DETECTIONS_LIST_RESET_STATUS)
    this.$store.dispatch(PRIVILEGED_ACTIONS_LIST_RESET_STATUS)

    // kill interval calls
    this.pollTacticAnalysis = function () {
    }
    destroyInverval(this.tacticIntervalId)
    window.removeEventListener('resize', this.debounceResize)
  },
  watch: {
    atRisk: {
      handler: function (newRisk, oldRisk) {
        if (!_.isUndefined(oldRisk) && newRisk !== oldRisk) {
          if (newRisk) {
            this.attackChainData.datasets[0].backgroundColor.forEach((bg, idx) => {
              this.attackChainData.datasets[0].backgroundColor[idx] = '#f24a6c'
            })
          } else {
            this.attackChainData.datasets[0].backgroundColor.forEach((bg, idx) => {
              this.attackChainData.datasets[0].backgroundColor[idx] = '#1a90fa'
            })
          }
          // this.$refs.tacticChart.renderDonutChart()
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    DonutChartJs
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.card-base {
  height: calc(100%);

  .widget-header {
    height: inherit;
  }

  .widget-info {
    height: calc(100% - 310px);
  }
}

.material-icons {
  font-size: 20px;
  color: var(--aluminum-400);
  line-height: 27px;
  vertical-align: text-top;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0px;
}

.widget-info {
  .el-divider--horizontal {
    width: 100%;
    margin-left: 0px;
  }

  &.active {
    background-color: var(--aluminum-100);
  }
}

span {
  margin-left: 10px;

  &.ml-20 {
    margin-left: 20px;
  }

  &.ml-0 {
    margin-left: 0px;
  }
}

.mitre-tatic:hover {
  background-color: var(--aluminum-100);
}

.hidden-center-button {
  position: relative;
  top: -200px;
  left: 25%;
  border-color: transparent;
  background-color: transparent;
  cursor: pointer;
  height: 100px;
  width: 150px;

  &:focus {
    outline: 0;
  }
}

.integrations-list,
.tactics-list {
  height: 60% !important;
  overflow: hidden;
}

.fa-angle-up {
  margin: 0px 10px;
}

.fa-angle-up,
.fa-angle-down {
  font-size: 1.5em;
  font-weight: 300;
}

.scroll-down {
  height: 18px;
  width: 116px;
  color: #a1a8ae;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/MitreTacticAnalysis.vue